import moment from "moment";
import SHA256 from "crypto-js/sha256";
import Vue from "vue";
var XMLparser = require("xml2json-light");

const L_API = process.env.VUE_APP_LASKUMAPPI_API;
const GOPI_URL = process.env.VUE_APP_GOPI 
//const GOPI_URL = "http://localhost:11001"

const AUTH_SERVER = GOPI_URL + "/token/auth";
const ADMIN_API = process.env.VUE_APP_ADMIN_API 

export const tokenHandler = {
  install(Vue, { store }) {
    let allowRefresh = true;
    Vue.http.interceptors.push((request, next) => {
      const userData = store.state.user.userData;
      if (allowRefresh) {
        const hasAuthHeader = request.headers.has("Authorization");
        if (hasAuthHeader) {
          request.headers.set(
            "Authorization",
            "Bearer " + store.state.user.authToken
          );
        } else {
          allowRefresh = false;
          return Vue.http(request);
        }
        next(response => {
          if (response.status == 403 || response.status == 400) {
            allowRefresh = false;
            return fetchAuthToken(userData.TransferID, userData.TransferKey).then(
              response => {
                store.commit("SET_AUTH_TOKEN", response.token);
                request.headers.set(
                  "Authorization",
                  "Bearer " + response.token
                );
                return Vue.http(request)
                  .then(response => {
                    return response;
                  })
                  .catch(response => {
                    return response;
                  });
              }
            );
          }
        })
      }
      allowRefresh = true;
    });
  }
};
export function fetchAuthToken(tid, tkey) {
  return new Promise((resolve, reject) => {
    let params = authParams(tid, tkey);
    Vue.http
      .get(AUTH_SERVER, { params: params })
      .then(response => response.json())
      .then(data => {
        resolve(data);
      })
      .catch(error => {
        reject(error);
      });
  });
}
const authParams = (tid, tkey) => {
  let t = moment()
    .utc()
    .format("YYYYMMDDHHmmss");
  let digest = "SHA-256:" + SHA256([tid, t, tkey].join("+"));

  return {
    TraID: tid,
    Timestamp: t,
    Digest: digest
  };
};
const digestStringWithValue = (args, value) => {
  //Ember.Logger.log(args.join('+'));
  if (value) {
    args.push(SHA256(value));
  }
  //Ember.Logger.log(args.join('+'));
  let digest = "SHA-256:" + SHA256(args.join("+"));
  //Ember.Logger.log(digest);
  return digest;
};

export const login = function({ name, pass }) {
  return new Promise((resolve, reject) => {
    let t = moment()
      .utc()
      .format("YYYYMMDDHHmmss");
    let d = digestStringWithValue([name, t], pass);
    Vue.http
      .get(L_API + "/authuser", {
        params: {
          uid: name,
          pass: "",
          t,
          d
        }
      })
      /* .then(response => response.json()) */
      .then(data => {
        if (data.status === 200) {
          data.json().then(data => {
            if (data.Response.Status === "OK") {
              resolve(data.Response.Content.Group);
            } else {
              reject("login.wrongPass");
            }
          })
        } else {
          reject("login.serviceDown")
        }

      })
      .catch(error => {
        reject(error);
      });
  });
};




export function validateXML(request) {
  return new Promise((resolve, reject) => {
    /*     let formData = new FormData();
        formData.append("SupplierList", file); */
        return Vue.http
          .put(GOPI_URL + "/schematron/finvoice", request, {
            headers: { Authorization: "dummy" }
          })
          .then(response =>
           {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
}